import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, Typography } from '@mui/material';
import baseURL from '../../baseURL';

const FinancialYearSelector = ({ value, onChange, showLabel = true, fullWidth = true }) => {
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentYear, setCurrentYear] = useState(null);

  useEffect(() => {
    fetchFinancialYears();
    fetchCurrentYear();
  }, []);

  const fetchFinancialYears = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${baseURL}/master/financial-years?limit=10000`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      if (data.success) {
        setYears(data.data || []);
      }
    } catch (error) {
      console.error('Error fetching financial years:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCurrentYear = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${baseURL}/master/financial-years/current`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      if (data.success && data.data) {
        setCurrentYear(data.data.yearName);
        // If no value is set, default to current year
        if (!value && onChange) {
          onChange(data.data.yearName);
        }
      }
    } catch (error) {
      console.error('Error fetching current financial year:', error);
    }
  };

  const handleChange = (event) => {
    const selectedYear = event.target.value;
    if (onChange) {
      onChange(selectedYear);
    }
  };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <FormControl fullWidth={fullWidth} size="small">
      {showLabel && <InputLabel>Financial Year</InputLabel>}
      <Select
        value={value || currentYear || ''}
        onChange={handleChange}
        label={showLabel ? 'Financial Year' : ''}
        displayEmpty
      >
        {years.map((year) => (
          <MenuItem key={year._id} value={year.yearName}>
            {year.yearName} {year.isCurrent && '(Current)'}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FinancialYearSelector;


